import React from 'react';
import { Box, Dialog, DialogContent, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export interface DialogProps {
  open: boolean;
  title: string;
  maxWidth: 'xs' | 'lg';
  children: any;
  onClose: () => void;
  titleClass?: any;
  modalStyle?: React.CSSProperties;
  overFlowVisible?: boolean;
}

const DialogOverflowYVisible = styled(Dialog)(() => ({
  '& .css-cyxlny-MuiPaper-root-MuiDialog-paper': {
    overflowY: 'visible',
  },
  '& .css-ypiqx9-MuiDialogContent-root': {
    overflowY: 'visible',
  },
  '& .css-40m75a-MuiPaper-root-MuiDialog-paper': {
    overflowY: 'visible',
  },
}));

const StyledDialog = styled(Dialog)();

export function CustomDialog({
  open,
  title,
  maxWidth,
  children,
  onClose,
  titleClass,
  modalStyle,
  overFlowVisible,
}: DialogProps) {
  return overFlowVisible ? (
    <DialogOverflowYVisible open={open} maxWidth={maxWidth} fullWidth onClose={onClose}>
      <Box px={2} py={1}>
        <Typography variant={'h4'} mt={2} ml={2.5} className={titleClass}>
          {title}
        </Typography>
        <DialogContent>
          <Box py={1} style={modalStyle}>
            {children}
          </Box>
        </DialogContent>
      </Box>
    </DialogOverflowYVisible>
  ) : (
    <StyledDialog open={open} maxWidth={maxWidth} fullWidth onClose={onClose}>
      <Box px={2} py={1}>
        <Typography variant={'h4'} mt={2} ml={2.5} className={titleClass}>
          {title}
        </Typography>
        <DialogContent>
          <Box py={1} style={modalStyle}>
            {children}
          </Box>
        </DialogContent>
      </Box>
    </StyledDialog>
  );
}
